import { observer } from 'mobx-react-lite';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { ControlIcons } from 'owa-control-icons';
import { SearchScenarioId } from 'owa-search-next-common';
import * as React from 'react';

const classNames = require('classnames');
const styles = require('./SearchGlyphShared.scss');

export interface SearchGlyphProps {
    onClick: (evt?: any) => void;
    searchBoxHasFocus: boolean;
    useNextSearchBoxInteractions: boolean;
    isSearchBoxDisabled: boolean;
    scenarioId: SearchScenarioId;
}

export default observer(function SearchGlyphLoading(props: SearchGlyphProps): JSX.Element {
    return (
        <div
            aria-hidden={true}
            className={classNames(
                styles.searchIcon,
                props.isSearchBoxDisabled && styles.isDisabled
            )}>
            <Icon iconName={ControlIcons.Search} />
        </div>
    );
});
